const FEATURE_FLAGS = {
  downloadReport: process.env.REACT_APP_FEAT_FLAG_DOWNLOAD_REPORT,
  environment: process.env.NODE_ENV === 'production' ? 'cashvest.us' : 'localhost'
};

export default FEATURE_FLAGS;
